import React, { useEffect, useState } from "react";
import Layouts from "../../../components/Layouts";
import { getDirectusClient } from "../../../lib/directus";
import { readItems, readUsers, readUser } from "@directus/sdk";
import { useSelector } from "react-redux";
import { Alert, Button, Space, Spin, Tree, Table } from "antd";
import { DatePicker, Modal, Select, message } from "antd";
import moment from "moment";
import Chart from "react-google-charts";
const { RangePicker } = DatePicker;
const { DirectoryTree } = Tree;

function Reportetree(props) {
  const [hoys, setHoys] = useState(true);
  const [userselect, setUserselect] = useState();
  const [total, setTotal] = useState(0);
  const userdata = useSelector((state) => state?.userdata);
  const [datareporte, setDatareporte] = useState([]);
  const [loanding, setLoanding] = useState(false);
  const [estadodatapicker, setestadodatapicker] = useState(false);
  const [treeData, setTreeData] = useState([]);

  const [estados, setEstados] = useState([]);
  const [startDate, setStartDate] = useState("2023-01-01");
  const [vendedores, setVendedores] = useState([]);
  var hoy = moment();
  var hoyf = hoy.add(1, "d").format("YYYY-MM-DD");

  const [endDate, setEndDate] = useState(hoyf);
  const getEstados = async () => {
    const directus = new getDirectusClient();
    try {
      const res = await directus.request(
        readItems("estados_gestion", {
          fields: ["id", "estado"],
          limit: -1,
          sort: "id",
        })
      );
      setEstados(res);
    } catch (err) {
      console.log(err);
    }
  };
  const getUsers = async () => {
    let arraycompleto = [];
    const directus = new getDirectusClient();
    try {
      const values = await directus.request(
        readUsers({
          fields: [
            "id",
            "first_name",
            "role.name",
            "subordinados.id",
            "subordinados.first_name",
            "subordinados.role.name",
            "subordinados.subordinados.id",
            "subordinados.subordinados.first_name",
          ],
          filter: {
            superior: {
              id: {
                _eq: userdata.id,
              },
            },
          },
        })
      );
      let arraysimple = [];

      values.map((value) => {
        if (
          value.role.name == "coordinador_ruta" ||
          value.role.name == "supervisor_ruta" ||
          value.role.name == "vendedor rutas"
        ) {
          let arraysub = [];
          value?.subordinados?.map((sub) => {
            let promoarr = [];
            sub?.subordinados?.map((promo) => {
              promoarr.push({
                title: promo?.first_name ? promo?.first_name : promo,
                key: promo?.id ? promo?.id : promo,
              });
            });
            arraysub.push({
              title: sub?.first_name,
              key: sub?.id,
              children: promoarr,
            });
          });
          arraysimple.push({
            title: value?.first_name,
            key: value?.id,
            children: arraysub,
          });
        }
      });

      arraycompleto.push({
        title: userdata?.first_name,
        key: userdata?.id,
        disabled: userdata?.role?.name == "gerente" ? true : false,
        children: arraysimple,
      });

      setTreeData(arraycompleto);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getUsers();
    getEstados();

    let fecha = moment().format("YYYY-MM-DD");
    let fechayhorainicial = fecha + " " + "12:00:00";
    let fechayhorafinal = fecha + " " + "23:59:00";

    setStartDate(fechayhorainicial);
    setEndDate(fechayhorafinal);
  }, []);

  const selectTree = (ev) => {
    setLoanding(true);
    setestadodatapicker(true);
    setUserselect(ev[0]);
    cargarReporte(ev[0], startDate, endDate);
  };

  const cargarReporte = async (userselect, startDate, endDate) => {
    try {
      setLoanding(true);
      const directus = new getDirectusClient();
      const datachart = [["estado", "Cantidad"]];

      const values = await directus.request(
        readUser(userselect, {
          fields: ["id", "first_name", "role.name"],
        })
      );

      // Build filter based on role
      let objf = {
        date_created: {
          _between: [startDate, endDate],
        },
      };

      console.log("rol seleccionado: ", values.role.name);

      if (values.role.name === "vendedor rutas") {
        objf.vendedor = { id: userselect };
      } else if (values.role.name === "supervisor_ruta") {
        objf.vendedor = { superior: { id: userselect } };
      } else if (values.role.name === "coordinador_ruta") {
        objf.vendedor = { superior: { superior: { id: userselect } } };
      }

      // Get total count
      const totalCount = await directus.request(
        readItems("gestion_cliente_rutero", {
          fields: ["id"],
          aggregate: { count: ["*"] },
          filter: objf,
        })
      );
      setTotal(totalCount[0].count);

      // Get estados
      const estados = await directus.request(
        readItems("estados_gestion", {
          fields: ["id", "estado"],
          limit: -1,
          sort: "id",
        })
      );

      const counts = await directus.request(
        readItems("gestion_cliente_rutero", {
          fields: ["*", "estado.*"],
          aggregate: { count: ["*"] },
          groupBy: ["estado"],
          filter: objf,
        })
      );

      console.log("counts: ", counts);

      counts.forEach(({ estado, count }) => {
        datachart.push([
          estados.find((e) => e.id === estado).estado,
          parseInt(count),
        ]);
      });

      let allVendedoresData = [];
      let offset = 0;
      const limit = 300;
      let hasMore = true;

      while (hasMore) {
        const vendedoresData = await directus.request(
          readItems("gestion_cliente_rutero", {
            fields: [
              "id",
              "vendedor.id",
              "vendedor.first_name",
              "estado.estado",
              "date_created",
            ],
            filter: objf,
            limit: limit,
            offset: offset,
          })
        );

        allVendedoresData = [...allVendedoresData, ...vendedoresData];

        if (vendedoresData.length < limit) {
          hasMore = false;
        } else {
          offset += limit;
        }
      }

      const vendedoresData = allVendedoresData;

      let allFacturas = [];
      let facturasOffset = 0;
      const facturasLimit = 300;
      let hasMoreFacturas = true;

      while (hasMoreFacturas) {
        const facturas = await directus.request(
          readItems("facturas", {
            fields: [
              "id",
              "gestion",
              "productos",
              "productos.precio_unitario",
              "productos.cantidad",
            ],
            filter: {
              gestion: {
                _nnull: true,
                date_created: {
                  _between: [startDate, endDate],
                },
              },
            },
            limit: facturasLimit,
            offset: facturasOffset,
          })
        );

        allFacturas = [...allFacturas, ...facturas];

        if (facturas.length < facturasLimit) {
          hasMoreFacturas = false;
        } else {
          facturasOffset += facturasLimit;
        }
      }

      const facturas = allFacturas;

      const groupedData = vendedoresData.reduce((acc, current) => {
        const vendedorId = current.vendedor.id;

        if (!acc[vendedorId]) {
          acc[vendedorId] = {
            vendedor: current.vendedor,
            estados: {},
            total: 0,
            facturados: 0,
            totalVentas: 0,
          };
        }

        const estado = current.estado.estado;
        acc[vendedorId].estados[estado] =
          (acc[vendedorId].estados[estado] || 0) + 1;
        acc[vendedorId].total += 1;

        const facturasGestion = facturas.filter(
          (f) => f.gestion === current.id
        );
        const totalVentasGestion = facturasGestion.reduce((sum, factura) => {
          const totalFactura =
            factura.productos?.reduce((subtotal, producto) => {
              return subtotal + producto.precio_unitario * producto.cantidad;
            }, 0) || 0;
          return sum + totalFactura;
        }, 0);

        acc[vendedorId].totalVentas += totalVentasGestion;
        acc[vendedorId].facturados += facturasGestion.length;

        return acc;
      }, {});

      // Convertir a array y formatear
      const processedData = Object.values(groupedData).map((item) => ({
        key: item.vendedor.id,
        vendedor: item.vendedor.first_name,
        ...item.estados,
        total: item.total,
        facturados: item.facturados,
        totalVentas: item.totalVentas,
      }));
      console.log("info", processedData);

      processedData.forEach((element) => {
        const gestionado = element["gestianado"] || 0;

        element.porcentaje =
          gestionado === 0 || element.total === 0 || element.total === undefined
            ? "0%"
            : `${((gestionado / element.total) * 100).toFixed(1)}%`;

        element.efectividad =
          gestionado === 0 ||
          element.facturados === 0 ||
          element.facturados === undefined
            ? "0%"
            : `${((element.facturados / gestionado) * 100).toFixed(2)}%`;
      });

      setVendedores(processedData);

      // Update chart data
      setDatareporte(datachart);
      setLoanding(false);
    } catch (error) {
      console.error("Error in cargarReporte:", error);
      setLoanding(false);
      message.error("Error al cargar el reporte");
    }
  };

  const onRangeChange = (dates, dateStrings) => {
    if (dates) {
      setLoanding(true);
      setHoys(false);
      setStartDate(dateStrings[0]);
      setEndDate(dateStrings[1]);
      cargarReporte(userselect, dateStrings[0], dateStrings[1]);
    } else {
      console.log("Clear");
    }
  };

  const dynamicColumns = estados.map((estado) => ({
    title:
      estado.estado === "activo"
        ? "Activo"
        : estado.estado === "gestion iniciada"
        ? "Gestion Iniciada"
        : estado.estado === "gestianado"
        ? "Gestionada"
        : estado.estado,
    dataIndex: estado.estado,
    key: estado.estado,
    render: (value) => value || 0,
  }));

  const columns = [
    {
      title: "Vendedor",
      dataIndex: ["vendedor"],
      key: "vendedor",
    },
    ...dynamicColumns,

    {
      title: "Clientes Asignados",
      dataIndex: "total",
      key: "total",
    },
    {
      title: "Facturados",
      dataIndex: "facturados",
      key: "facturados",
      render: (value) => value || 0,
    },
    {
      title: "Total Ventas",
      dataIndex: "totalVentas",
      key: "totalVentas",
      render: (value) => `$${(value || 0).toLocaleString()}`,
    },
    {
      title: "Porcentaje Gestionado",
      dataIndex: "porcentaje",
      key: "porcentaje",
    },
    {
      title: "Efectividad",
      dataIndex: "efectividad",
      key: "efectividad",
    },
  ];

  return (
    <Layouts>
      <Space>
        <Button
          onClick={() => {
            let fecha = moment().format("YYYY/MM/DD");
            let fechayhorainicial = fecha + " " + "12:00:00";
            let fechayhorafinal = fecha + " " + "23:59:00";
            console.log(fechayhorainicial);
            setStartDate(fechayhorainicial);
            setEndDate(fechayhorafinal);
            console.log(fechayhorafinal);
            setHoys(true);
            if (userselect) {
              cargarReporte(userselect, fechayhorainicial, fechayhorafinal);
            }
          }}
        >
          Hoy
        </Button>

        <RangePicker
          disabled={!estadodatapicker}
          format={{ format: "YYYY/MM/DD HH:mm:ss", type: "mask" }}
          onChange={onRangeChange}
          placeholder={["Fecha inicial", "Feha final"]}
        />
      </Space>
      <br></br>
      <Space>
        <DirectoryTree
          showLine={true}
          onSelect={selectTree}
          onExpand={(e) => console.log()}
          treeData={treeData}
        />
      </Space>

      <br />

      <Spin spinning={loanding} delay={500}>
        <Space>
          <h3>
            {hoys
              ? "Mostrando datos de hoy: " + moment().format("YYYY-MM-DD")
              : "Mostrando filtro entre fechas " + startDate + "--" + endDate}
          </h3>
          <h3 style={{ color: "green" }}>Total: {total}</h3>
        </Space>
        <Chart
          chartType="PieChart"
          width={"100%"}
          height={"400px"}
          loader={<div>Cargando gráfica</div>}
          data={datareporte}
          options={{
            title: "Reporte de portabilidades por estado",
            is3D: true,
            backgroundColor: "transparent",
            chartArea: { width: "100%", height: "80%" },
            legend: { position: "bottom" },
          }}
        />
        <Table
          dataSource={vendedores}
          columns={columns}
          rowKey="id"
          loading={loanding}
          pagination={{ pageSize: 10 }}
        />
      </Spin>
    </Layouts>
  );
}

export default Reportetree;
